import React from "react";

type LoaderProps = {
  size?: number | string;
  className?: string;
  "aria-label"?: string;
};

const Loader: React.FC<LoaderProps> = ({
  size = 48,
  className = "",
  "aria-label": ariaLabel = "Loading",
}) => (
  <div
    className={`animate-spin rounded-full border-b-2 border-sangati-green mx-auto ${className}`}
    style={{ height: size, width: size }}
    role="status"
    aria-label={ariaLabel}
    tabIndex={0}
  />
);

export default Loader;
